import Vue from 'vue';
import VueRouter from 'vue-router';
import Store_GF from '../store/store.js';
import Dashboard from '../dashboard.vue';
/* component individual */
import Index_individual from '../components/individual/Individual.vue';
import Charity_individual from '../components/individual/charity.vue';
import Event_individual from '../components/individual/event.vue';
import Complete_individual from '../components/individual/complete.vue';
/* component team */
import Index_team from '../components/team/Team.vue'
import Charity_team from '../components/team/charity.vue';
import Event_team from '../components/team/event.vue';
import Complete_team from '../components/team/complete.vue';
/* component jointeam */
import Index_JoinTeam from '../components/jointeam/JoinTeam.vue';
import Select_team from '../components/jointeam/select_team.vue';
import Complete_JoinTeam from '../components/jointeam/complete.vue';
import FacebookConnect from '../components/login/FacebookConnect.vue';

Vue.use(VueRouter);

const MiddleJoinTeamPre = (to, from, next) => {
  if (Store_GF.state.data_params_pre.teamId == '') {
    next();
  }
  next(false);
}
const MiddlewareCompleteIndividual = (to, from, next) => {
  if (Store_GF.state.selected_charity != '' && Store_GF.state.selected_event != '') {
    next();
  }
  next(false);
}
const MiddlewareCompleteTeam = (to, from, next) => {
  if (Store_GF.state.selected_charity != '' && Store_GF.state.selected_event != '') {
    next();
  }
  next(false);
}
const MiddlewareCompleteJoinTeam = (to, from, next) => {
  if (Store_GF.state.selected_teampage != '') {
    next();
  }
  next(false);
}

const routes = [
  {
    path: '/',
    component: Dashboard,
    name: 'dashboard'
  },
  {
    path: '/individual',
    component: Index_individual,
    name: 'index_individual',
    beforeEnter: MiddleJoinTeamPre,
    children: [{
        path: 'charity',
        component: Charity_individual,
        name: 'charity_individual',
        beforeEnter: (to, from, next) => {
          if (Store_GF.state.data_params_pre.beneficiaryId != '') {
            if(Store_GF.state.data_params_pre.eventId != ''){
              next({
                name: 'complete_individual'
              });
            }else{
              next({
                name: 'event_individual'
              });
            }
          } else {
            next();
          }
        }
      },
      {
        path: 'event',
        component: Event_individual,
        name: 'event_individual',
        beforeEnter: (to, from, next) => {
          if (Store_GF.state.data_params_pre.eventId != '') {
            if(Store_GF.state.data_params_pre.beneficiaryId != ''){
              next({
                name: 'complete_individual'
              });
            }else{
              next({
                name: 'charity_individual'
              });
            }

          } else {
            next();
          }
        }
      },
      {
        path: 'complete',
        component: Complete_individual,
        name: 'complete_individual',
        beforeEnter: MiddlewareCompleteIndividual
      }
    ]
  },
  {
    path: '/team',
    component: Index_team,
    name: 'index_team',
    beforeEnter: MiddleJoinTeamPre,
    children: [{
        path: 'charity',
        component: Charity_team,
        name: 'charity_team',
        beforeEnter: (to, from, next) => {
          if (Store_GF.state.data_params_pre.beneficiaryId != '') {
            if(Store_GF.state.data_params_pre.eventId != ''){
              next({
                name: 'complete_team'
              });
            }else{
              next({
                name: 'Event_team'
              });
            }
          } else {
            next();
          }
        }
      },
      {
        path: 'event',
        component: Event_team,
        name: 'Event_team',
        beforeEnter: (to, from, next) => {
          if (Store_GF.state.data_params_pre.eventId != '') {
            if(Store_GF.state.data_params_pre.beneficiaryId != ''){
              next({
                name: 'complete_team'
              });
            }else{
              next({
                name: 'charity_team'
              });
            }
          } else {
            next();
          }
        }
      },
      {
        path: 'complete',
        component: Complete_team,
        name: 'complete_team',
        beforeEnter: MiddlewareCompleteTeam
      }
    ]
  },
  {
    path: '/jointeam',
    component: Index_JoinTeam,
    name: 'index_jointeam',
    children: [{
        path: 'select_team',
        component: Select_team,
        name: 'select_team'
      },
      {
        path: 'complete',
        component: Complete_JoinTeam,
        name: 'complete_jointeam',
        beforeEnter: MiddlewareCompleteJoinTeam,
      }
    ]
  },
  {
    path: '/connect',
    component: FacebookConnect,
    name: 'connect',
    props: true
  },
];

const router = new VueRouter({
  routes
});

export default router;
